import gql from 'graphql-tag';

const createOrUpdateAuctionLocationMutation = gql`
  mutation createOrUpdateAuctionLocation(
    $auctionLocation: AuctionLocationInputObjectType!
  ) {
    createOrUpdateAuctionLocation(
      input: { auctionLocation: $auctionLocation }
    ) {
      success
      errors
      msg
    }
  }
`;

export default createOrUpdateAuctionLocationMutation;
